import {Timestamp} from "firebase/firestore";

export enum EventType {
    PROGRESS = "PRO",
    START = "S",
    FINISH = "F",
    LOG_ISSUE = "ISS",
    REFORECAST = "RE",
    EXTEND = "EX",
    BLOCK = "BLK",
    UNBLOCK = "UBLK",
    SUSPEND = "SUS",
    RESUME = "RES"

}

export class PlaylistModel {
    playlistId: string;
    userId: string;
    contractId: string;
    timestamp: Timestamp;
    playlistComplete: boolean;
    initialItems: number;
    completedItems: number;
    additionalItems: number;
}

export class PlaylistItemModel {
    dateString: string;
    contractId: string;
    eventType: EventType;
    taskId: string;
    taskCode: string;
    paused?: boolean;
}

export class CompletedPlaylistItemModel {
    dateString: string;
    contractId: string;
    playlistItemId: string;
    eventType: EventType;
    eventPrompt: EventType;
    taskId: string;
    taskCode: string;
    completedTimestamp: Timestamp;
    userId: string;
}
